import { MapaVisibilidade } from '@/global/components/DataGrid/utils/columnVisibilityStorage'
import { CreateSlice } from './index'

export type ValorVariavel = string | number | boolean

export type DataTableState = {
    dataTable: {
        pagination: {
            pageSize: number | undefined
            setPageSize: (pageSize: number) => void
        }
        /** Visibilidade de colunas por tabela, indexada pelo `tableId` do DataTable. */
        colunas: Record<string, MapaVisibilidade>
        /** `mapa` undefined remove o registro da tabela — é o "redefinir padrão". */
        setColunas: (tableId: string, mapa?: MapaVisibilidade) => void
        /** Estado avulso de tela por tabela (ex: `filtrarPor` de horas trabalhadas). */
        variaveis: Record<string, Record<string, ValorVariavel>>
        setVariavel: (
            tableId: string,
            chave: string,
            valor: ValorVariavel,
        ) => void
    }
}

export const createDataTableSlice: CreateSlice<DataTableState> = (
    set,
    get,
) => ({
    dataTable: {
        pagination: {
            pageSize: undefined,
            setPageSize: (pageSize: number) => {
                set({
                    ...get(),
                    dataTable: {
                        ...get().dataTable,
                        pagination: {
                            ...get().dataTable.pagination,
                            pageSize,
                        },
                    },
                })
            },
        },
        colunas: {},
        setColunas: (tableId, mapa) => {
            const colunas = { ...get().dataTable.colunas }

            if (mapa === undefined) delete colunas[tableId]
            else colunas[tableId] = mapa

            set({
                ...get(),
                dataTable: {
                    ...get().dataTable,
                    colunas,
                },
            })
        },
        variaveis: {},
        setVariavel: (tableId, chave, valor) => {
            set({
                ...get(),
                dataTable: {
                    ...get().dataTable,
                    variaveis: {
                        ...get().dataTable.variaveis,
                        [tableId]: {
                            ...get().dataTable.variaveis[tableId],
                            [chave]: valor,
                        },
                    },
                },
            })
        },
    },
})
